module.exports = __webpack_public_path__ + "static/media/Piercing-mouth.1e7d0b58.png";